const easeLinear = (t: number): number => t;
const easeOutQuart = (t: number): number => 1 - (1 - t) ** 4;
const easeOutCubic = (t: number): number => 1 - (1 - t) ** 3;

const easingByName: Record<string, (t: number) => number> = {
  linear: easeLinear,
  "ease-out-cubic": easeOutCubic,
  "ease-out-quart": easeOutQuart,
};

const defaultDurationMs = 650;

const getEasing = (el: HTMLElement) => {
  const key = el.getAttribute("data-easing")?.trim().toLowerCase();
  return key ? (easingByName[key] ?? easeOutQuart) : easeLinear;
};

const getDuration = (el: HTMLElement) => {
  const value = Number.parseFloat(el.getAttribute("data-duration") ?? "");

  return Number.isFinite(value) && value > 0 ? value * 1000 : defaultDurationMs;
};

export default function MetricsGrid() {
  const grids = document.querySelectorAll<HTMLElement>(".js-metrics-grid");

  grids.forEach((grid) => {
    const items = Array.from(grid.querySelectorAll<HTMLElement>("[data-count]"));

    if (!items.length) return;

    let animated = false;

    const animateGrid = () => {
      if (animated) return;
      animated = true;

      const startTime = performance.now();

      const counters = items.map((item) => ({
        element: item,
        endValue: Math.max(Number.parseInt(item.getAttribute("data-count") ?? "0", 10) || 0, 0),
        duration: getDuration(item),
        easing: getEasing(item),
      }));

      const tick = (now: number) => {
        const elapsed = now - startTime;
        let complete = true;

        for (const counter of counters) {
          const progress = Math.min(elapsed / counter.duration, 1);
          const eased = counter.easing(progress);
          const value = Math.floor(eased * counter.endValue);

          counter.element.textContent = String(value);

          if (progress < 1) {
            complete = false;
          }
        }

        if (!complete) {
          requestAnimationFrame(tick);
        }
      };

      requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          observer.disconnect();
          animateGrid();
        }
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -10% 0px",
      },
    );

    observer.observe(grid);
  });
}
